import React, { useEffect, useState, useRef } from 'react';
export function ProblemSolution() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const searches = ['"High protein restaurants near me"', '"Low calorie lunch options"', '"Healthy food downtown"'];
  return <div ref={sectionRef} className="py-32 md:py-40 bg-charcoal-900 dark:bg-charcoal-900" data-id="element-228">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-229">
        <div className={`mb-12 transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-white" data-id="element-231">
            You've Googled this 100 times:
          </h2>
          <div className="space-y-6 mb-16" data-id="element-232">
            {searches.map((search, index) => <div key={index} className={`bg-charcoal-800 border border-charcoal-700 rounded-2xl p-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
            transitionDelay: `${index * 150}ms`
          }} data-id="element-233">
                <p className="text-xl md:text-2xl text-charcoal-200 font-light" data-id="element-234">
                  {search}
                </p>
              </div>)}
          </div>
        </div>
        <div className={`transition-all duration-1000 delay-500 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-235">
          <p className="text-2xl md:text-3xl text-white/60 mb-8 font-light" data-id="element-236">
            The results? Useless.
          </p>
          <p className="text-3xl md:text-4xl text-white font-bold" data-id="element-237">
            Caltalk gives you actual answers.
          </p>
        </div>
      </div>
    </div>;
}